export default {
  courierServiceFee: '/gateway'
}
